import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled, { css } from "styled-components";
export var StickySaveProfileButton = function(param) {
    var onClickPromise = param.onClickPromise, disabled = param.disabled, isVisible = param.isVisible, errorMessage = param.errorMessage, children = param.children, dataTestId = param["data-test-id"];
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(undefined), 2), saveError = _React_useState1[0], setSaveError = _React_useState1[1];
    var handleButtonClicked = function() {
        setLoading(true);
        setSaveError(undefined);
        onClickPromise().then(function() {
            setLoading(false);
        }).catch(function() {
            setSaveError(strictLocalize({
                id: "W/5hwr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Something went wrong. Please try again."
                    }
                ]
            }));
            setLoading(false);
        });
    };
    var errorToDisplay = errorMessage || saveError;
    return /*#__PURE__*/ _jsxs(StickyColumn, {
        $isVisible: isVisible,
        children: [
            /*#__PURE__*/ _jsx(StyledButton, {
                onClick: handleButtonClicked,
                disabled: disabled,
                "data-test-id": dataTestId,
                loading: loading,
                children: children
            }),
            errorToDisplay ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.critical,
                        children: errorToDisplay
                    })
                ]
            }) : null
        ]
    });
};
var StickyColumn = styled(Column).withConfig({
    componentId: "sc-7a503188-0"
})([
    "position:sticky;bottom:0;z-index:1;background-color:",
    ";border-top:1px solid ",
    ";width:calc(100% + 30px);margin:20px -15px 0;padding:24px 15px;transition:opacity 0.2s ease,transform 0.2s ease;",
    ";",
    "{width:calc(100% + 100px);margin:20px -50px -20px;padding:24px 50px;}"
], Core.surface.inverse, Core.border.muted, function(props) {
    return props.$isVisible ? css([
        "opacity:1;transform:translateY(0);"
    ]) : css([
        "opacity:0;transform:translateY(100%);"
    ]);
}, responsiveMediaQueries.desktopAndAbove);
var StyledButton = styled(Button).withConfig({
    componentId: "sc-7a503188-1"
})([
    "width:100%;",
    "{max-width:380px;}"
], responsiveMediaQueries.tabletAndAbove);
